'use client';
import styles from './SimpleSystem.module.scss';
import Image from 'next/image';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { useState } from 'react';
import { IconRightChevron } from '@/public/assets/icons/IconRightChevron';
import Percent15 from '@/public/assets/Images/SimpleSystem15.svg';
import Percent5 from '@/public/assets/Images/SimpleSystem5.svg';
import Percent7 from '@/public/assets/Images/SimpleSystem7.svg';
import BGPattern from '@/public/assets/Images/BGPattern.svg';
import sliderImage1 from '@/public/assets/Images/HeaderImageFront.svg';
import sliderImage2 from '@/public/assets/Images/HeaderImageBack.svg';
import HeaderImageFrontEng from '@/public/assets/Images/HeaderImageFrontEng.svg';
import HeaderImageBackEng from '@/public/assets/Images/HeaderImageBackEng.svg';
import { useLocale, useTranslations } from 'next-intl';

export const SimpleSystem = () => {
  const t = useTranslations('ui.simpleSystem');
  const locale = useLocale();
  const percents = [
    {
      src: Percent15,
      alt: '15 percent',
      text: t('increase'),
    },
    { src: Percent5, alt: '5 percent', text: t('one') },
    { src: Percent7, alt: '7 percent', text: t('two') },
  ];
  const localeImage1 = locale === 'en' ? HeaderImageFrontEng : sliderImage1;
  const localeImage2 = locale === 'en' ? HeaderImageBackEng : sliderImage2;
  const sliderImages = [localeImage1, localeImage2];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    loop: true,
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel);
    },
  });

  const goPrev = () => {
    if (slider.current) slider.current.prev();
  };
  const goNext = () => {
    if (slider.current) slider.current.next();
  };
  const goToSlide = (idx: number) => {
    if (slider.current) slider.current.moveToIdx(idx);
  };
  return (
    <section className={styles.container}>
      <figure>
        <Image
          className={styles.BGPattern}
          src={BGPattern}
          alt="background grid plan gr"
          width={1400}
          height={769}
        />
      </figure>
      <div className={styles.containerContent}>
        <div id="screens" className={styles.heading}>
          <h2>
            {t('title')} <span>{t('titleTwo')}</span>
          </h2>
          <h4>{t('subtitle')}</h4>
        </div>

        <div className={styles.percentWrapper}>
          {percents.map((perc) => (
            <div key={perc.text} className={styles.percentElement}>
              <figure>
                <Image src={perc.src} alt={perc.alt} width={303} height={134} />
              </figure>
              <h6>{perc.text}</h6>
            </div>
          ))}
        </div>

        <button className={styles.buttonDemo}>{t('demo')}</button>

        <div className={styles.sliderContainer}>
          <div ref={sliderRef} className={`keen-slider ${styles.slider}`}>
            {sliderImages.map((src, i) => (
              <div key={i} className="keen-slider__slide">
                <figure
                  className={locale === 'en' ? styles.imageEn : styles.imageRu}
                >
                  <Image src={src} alt="slider" width={1160} height={779} />
                </figure>
              </div>
            ))}
          </div>

          <button
            className={`${styles.arrow} ${styles.arrowLeft}`}
            onClick={goPrev}
          >
            <IconRightChevron />
          </button>
          <button
            className={`${styles.arrow} ${styles.arrowRight}`}
            onClick={goNext}
          >
            <IconRightChevron />
          </button>

          <div className={styles.dotsWrapper}>
            {sliderImages.map((_, idx) => (
              <button
                key={idx}
                className={`${styles.dot} ${
                  currentSlide === idx ? styles.active : ''
                }`}
                onClick={() => goToSlide(idx)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
